import { render, staticRenderFns } from "./FooterButton.vue?vue&type=template&id=6faf0daa&scoped=true&"
import script from "./FooterButton.vue?vue&type=script&lang=ts&"
export * from "./FooterButton.vue?vue&type=script&lang=ts&"
import style0 from "./FooterButton.vue?vue&type=style&index=0&id=6faf0daa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faf0daa",
  null
  
)

export default component.exports